import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';

export class dmHotel {
    IsAuthenticated:    boolean;
    IsNotAuthenticated: boolean;
    InSignInOut:        boolean;

    ChainWantsHotelID:  number;

    HotelID:            number;
    LangID:             number;
    UserName:           string;
    Password:           string;
    HotelCurrency:      string;

    PoliciesURI:        string;
    HPageURI:           string;
    HPageTemplateURI:   string;

    WithHousekeeping:   boolean;
    WithEngineTemplate: boolean;

    IsWebContext:       boolean;

    IsAutoLogin:        boolean;
    IsEnableRequest:    boolean;
    IsSessionExpired:   boolean;

    IsViaNearby:        boolean;

    HotelInfo:          RQService.Ota.GetHotelInfoRow;

    MarkURISafe:        (pURI: string) => any;

    constructor(
         pLangID:      number
        ,pMarkURISafe: (pURI: string) => any
    ) {
        this.IsAuthenticated    = false;
        this.IsNotAuthenticated = true;
        this.InSignInOut        = false;
        this.IsWebContext       = true;
        this.IsAutoLogin        = false;
        this.IsEnableRequest    = false;
        this.IsSessionExpired   = false;
        this.IsViaNearby        = false;

        this.ChainWantsHotelID  = 0;

        this.HotelID            = 0;
        this.LangID             = pLangID;
        this.UserName           = '';
        this.Password           = '';
        this.HotelCurrency      = '';

        this.PoliciesURI
            = 'https://www.tobook.com/tool/policies/policyQuestionnaireOTA.asp?page=0';

        this.HPageURI           = '';
        this.HPageTemplateURI   = '';

        this.HotelInfo          = null;

        this.MarkURISafe        = pMarkURISafe;

        this.resetHotelDetails();
    }

    private resetHotelDetails(): void {
        this.ChainWantsHotelID  = 0;

        this.HotelID            = 0;
        this.UserName           = '';
        this.Password           = '';
        this.WithHousekeeping   = false;
        this.WithEngineTemplate = false;
        this.IsViaNearby        = false;

        this.PoliciesURI
            = 'https://www.tobook.com/tool/policies/policyQuestionnaireOTA.asp?page=0';

        this.HPageURI         = '';
        this.HPageTemplateURI = '';
    }

    private retrieveHotelDetails(
        pAction: () => void
    ) {
        let hotelInfo = RQParam.OtaGetHotelInfoParams();

        hotelInfo.HotelID = this.HotelID;
        hotelInfo.LangID  = this.LangID;

        RQService.Ota.GetHotelInfo(hotelInfo).then(result => {
            if (result.HasErrorOrException) { pAction(); return; }

            console.log('hotel details retrieved');

            let hotelDetails: RQService.Ota.GetHotelInfoRow
                = RQService.Ota.PopulateGetHotelInfoRow(
                    result.RQueryResult[0]
                );

            this.HotelInfo = hotelDetails;

            if (this.HotelInfo.HotelCurrencySymbol != '') {
                this.HotelCurrency
                    = this.HotelInfo.HotelCurrencySymbol
                    + ' ('
                    + this.HotelInfo.HotelCurrencyShortEn
                    + ')';
            } else {
                this.HotelCurrency = this.HotelInfo.HotelCurrencyShortEn;
            }

            if (
                this.HotelInfo.ServiceTypeID >= 3
            &&  this.HotelInfo.ServiceTypeID < 10
            ) {
                this.WithHousekeeping   = true;
            }

            if (this.HotelInfo.HotelHasEngineTemplate == 1)
            {
                this.WithEngineTemplate = true;
            }

            if (this.HotelInfo.IsNearbyActivation == 1)
            {
                this.IsViaNearby        = true;
            }

            this.HPageURI
                = 'https://www.tobook.com/'
                + this.HotelInfo.CountryPName
                + '/Hotels/'
                + this.HotelInfo.HotelPName
                + '?CityPName='
                + this.HotelInfo.CityPName;

            this.HPageTemplateURI
                = 'https://www.tobook.com/en/'
                + this.HotelInfo.CountryPName
                + '/'
                + this.HotelInfo.CityPName
                + '/'
                + this.HotelInfo.HotelPName
                + '/EngineService/AvailableRooms';

            this.IsSessionExpired = false;

            pAction();
        });
    }

    private retrievePassword(
        pAction: () => void
    ): void {
        let passParams = RQParam.OtaGetHotelPasswordParams();

        passParams.HotelID = this.HotelID;

        RQService.Ota.GetHotelPassword(passParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { pAction(); return; }

            let pass = RQService.Ota.PopulateGetHotelPasswordRow(
                response.RQueryResult[0]
            );

            this.Password = pass.Password;

            this.PoliciesURI
                = 'https://www.tobook.com/tool/policies/policyQuestionnaireOTA.asp?page=0&Login='
                + this.UserName
                + '&Password='
                + this.Password;

            pAction();
        });
    }

    private clearSession(
        pAction: () => void
    ): void {
        this.IsAuthenticated    = false;
        this.IsNotAuthenticated = true;

        RQApp.SetSession('NO_API_KEY', '');

        this.resetHotelDetails();

        this.InSignInOut = false;

        pAction();
    }

    public RetrieveHotelDetails(
        pAction: () => void
    ) { this.retrieveHotelDetails(pAction); }

    public GetPoliciesURI(): any {
        return this.MarkURISafe(this.PoliciesURI);
    }

    public GetHotelPageURI(): any {
        return this.MarkURISafe(this.HPageURI);
    }

    public GetHotelEngineTemplateURI(): any {
        return this.MarkURISafe(this.HPageTemplateURI);
    }

    public CheckSession(
        pPredicate: (pIsAuthenticated: boolean) => void
    ): void {
        if (this.InSignInOut) { return; }

        let apiKey: string = RQApp.GetAPIKey();

        console.log('apikey: ' + apiKey);

        if (
            apiKey == 'RES_HOTEL_LOGIN'
        ||  (
                apiKey                 == 'RES_CHAIN_LOGIN'
            &&  this.ChainWantsHotelID >  0
            )
        ) {
            this.InSignInOut = true;

            RQService.Auth.RQSession().then(result => {
                if (result.HasErrorOrException) { this.InSignInOut = false; return; }

                let session: RQService.Auth.RQSessionRow
                    = RQService.Auth.PopulateRQSessionRow(
                        result.RQueryResult[0]
                    );

                if (session.IsAuthenticated) {
                    if (session.RoleID == 10) {
                        let chainParams = RQParam.OtaHotelBelongsToChainParams();

                        chainParams.HotelChainID = session.AccountID;
                        chainParams.HotelID      = this.ChainWantsHotelID;

                        RQService.Ota.HotelBelongsToChain(chainParams).then((result) => {
                            let response = result as any;

                            if (response.HasErrorOrException) {
                                this.clearSession(() => { pPredicate(false); })

                                return;
                            }

                            let belongs = RQService.Ota.PopulateHotelBelongsToChainRow(
                                response.RQueryResult[0]
                            );

                            if (belongs.HotelBelongsToChain == 1) {
                                this.IsAuthenticated    = true;
                                this.IsNotAuthenticated = false;

                                this.HotelID  = this.ChainWantsHotelID;
                                this.UserName = session.AccountName;

                                this.retrieveHotelDetails(() => {
                                    this.InSignInOut = false;

                                    this.retrievePassword(() => { pPredicate(true); });
                                });
                            } else {
                                this.clearSession(() => { pPredicate(false); })
                            }
                        });
                    } else if (session.RoleID == 8)  {
                        this.IsAuthenticated    = true;
                        this.IsNotAuthenticated = false;
                        
                        this.HotelID  = session.EntityID;
                        this.UserName = session.AccountName;

                        this.retrieveHotelDetails(() => {
                            this.InSignInOut = false;

                            this.retrievePassword(() => { pPredicate(true); });
                        });
                    } else {
                        this.clearSession(() => { pPredicate(false); })
                    }
                } else {
                    this.clearSession(() => { pPredicate(false); });
                }
            });
        } else {
            RQApp.SetSession('NO_API_KEY', '');

            pPredicate(false);
        }
    }

    public SignIn(
         pUserName:    string
        ,pCredentials: string
        ,pAction:      (pAuthResult: RQService.Auth.RQLoginRow) => void
    ): void {
        if (this.InSignInOut || this.IsAuthenticated) { return; }

        let login: RQParam.AuthLogin = RQParam.AuthLoginParams();

        login.AccountID     = 0;
        login.AccountName   = pUserName;
        login.Credentials   = pCredentials;
        login.EntityGroupID = 0;
        login.EntityID      = this.HotelID;
        login.EntityTypeID  = 1;
        login.RoleID        = 8;
        login.RQueryAPIKey  = 'RES_HOTEL_LOGIN';

        this.InSignInOut    = true;

        RQService.Auth.RQLogin(login).then((result) => {
            if (result.HasErrorOrException) { this.InSignInOut = false; return; }

            let loginStatus: RQService.Auth.RQLoginRow = RQService.Auth.PopulateRQLoginRow(
                result.RQueryResult[0]
            );

            if (loginStatus.IsAuthenticated) {
                console.log('login ok: ' + loginStatus.RQueryAuthToken);

                RQApp.SetSession(
                     loginStatus.RQueryAPIKey
                    ,loginStatus.RQueryAuthToken
                );

                this.IsAuthenticated    = true;
                this.IsNotAuthenticated = false;

                this.HotelID  = loginStatus.EntityID;
                this.UserName = loginStatus.AccountName;
                this.Password = pCredentials;

                this.PoliciesURI
                    = 'https://www.tobook.com/tool/policies/policyQuestionnaireOTA.asp?page=0&Login='
                    + this.UserName
                    + '&Password='
                    + this.Password;

                this.retrieveHotelDetails(() => {
                    pAction(loginStatus);

                    this.InSignInOut = false;
                });
            } else {
                this.IsAuthenticated    = false;
                this.IsNotAuthenticated = true;

                RQApp.SetSession('NO_API_KEY', '');

                this.resetHotelDetails();

                pAction(loginStatus);

                this.InSignInOut = false;
            }
        });
    }

    public SignOut(
        pAction: (pLogoutResult: RQService.Auth.RQLogoutRow) => void
    ): void {
        if (this.InSignInOut || this.IsNotAuthenticated) { return; }

        this.InSignInOut = true;

        RQService.Auth.RQLogout().then(result => {
            if (result.HasErrorOrException) { this.InSignInOut = false; return; }

            console.log('logout');

            let logoutStatus: RQService.Auth.RQLogoutRow = RQService.Auth.PopulateRQLogoutRow(
                result.RQueryResult[0]
            );

            this.IsAuthenticated    = false;
            this.IsNotAuthenticated = true;

            RQApp.SetSession('NO_API_KEY', '');

            this.resetHotelDetails();

            pAction(logoutStatus);

            this.InSignInOut = false;
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/sign-in/xv-hotel.ts